/**
 * RbsPortalBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserDto { 
    id?: string;
    username?: string | null;
    email?: string | null;
    firstname?: string | null;
    lastname?: string | null;
    department?: string | null;
    approvalLimit?: number;
    lastLoginDate?: string;
    isApproved?: boolean;
    userRoles?: Array<string> | null;
    applicationRoles?: Array<string> | null;
}

